// extracted by mini-css-extract-plugin
export default {"btnSection":"styles_btnSection__bR89U","cancelButton":"styles_cancelButton__XBJEU","confirmButton":"styles_confirmButton__oLhE+"};